// SALDP white-labelling. Added by Sullivan Digital, 2026-10-26. Licensed under the GNU AGPL v3; see LICENSE-AGPL.txt.
import { useSelector } from "metabase/redux";
import { Image, useColorScheme } from "metabase/ui";

import { getBrandLogoUrl, getBrandName } from "../../selectors";

interface BrandLogoProps {
  width?: number;
  height?: number;
  /** Rendered on a dark background regardless of the colour scheme, e.g. the admin nav bar. */
  dark?: boolean;
}

export function BrandLogo({ width, height = 32, dark }: BrandLogoProps) {
  const { resolvedColorScheme } = useColorScheme();
  const colorScheme = dark ? "dark" : resolvedColorScheme;
  const logoUrl = useSelector((state) => getBrandLogoUrl(state, colorScheme));
  const brandName = useSelector(getBrandName);

  return (
    <Image
      src={logoUrl}
      alt={brandName}
      h={height}
      w={width ?? "auto"}
      maw="100%"
      fit="contain"
      data-testid="main-logo"
    />
  );
}
